import {autoImplement} from '@/util';

export interface ApiClient {
  MandantNr: number;
  KurzBezeichnung: string;
  Name: string;
}

export interface ClientFilters {
}

export default class Client extends autoImplement<ApiClient>() {
  static fromApi(apiClient: ApiClient): Client {
    return new Client(apiClient);
  }
}
